export const features = [
    "Public and private chat",
    "Event scheduler",
    "Appoitment scheduling",
    "No prior credit card required",
    "Group video calls",
    "Expert on demad call",
    "Email support for 24/7",
    "Activity Stream",
    "Appoitment scheduling",
]